module.exports = __webpack_public_path__ + "img/pen-icon.4205afba.svg";